import { useAuthStore } from '@/stores/authStore'
import { useUIStore } from '@/stores/uiStore'
import { Menu, Bell, Search } from 'lucide-react'
import { cn, getInitials } from '@/lib/utils'

export function Header() {
  const { profile } = useAuthStore()
  const { toggleSidebar } = useUIStore()

  return (
    <header className="h-14 bg-white border-b border-surface-200 flex items-center justify-between px-4 shrink-0">
      <div className="flex items-center gap-3">
        <button
          onClick={toggleSidebar}
          className="lg:hidden text-surface-500 hover:text-surface-700 p-1"
          aria-label="Open menu"
        >
          <Menu className="w-5 h-5" />
        </button>

        {/* Search */}
        <div className="hidden sm:flex items-center gap-2 bg-surface-100 rounded-md px-3 h-8 w-64">
          <Search className="w-3.5 h-3.5 text-surface-400" />
          <input
            type="text"
            placeholder="Search tickets..."
            className="bg-transparent text-sm text-surface-700 placeholder:text-surface-400 outline-none w-full"
          />
        </div>
      </div>

      <div className="flex items-center gap-2">
        {/* Notifications */}
        <button
          className={cn(
            'relative p-2 rounded-md text-surface-500 hover:text-surface-700',
            'hover:bg-surface-100 transition-colors'
          )}
          aria-label="Notifications"
        >
          <Bell className="w-4 h-4" />
          <span className="absolute top-1.5 right-1.5 w-1.5 h-1.5 rounded-full bg-danger-500" />
        </button>

        {/* User avatar */}
        {profile && (
          <div className="flex items-center gap-2 pl-2 border-l border-surface-200">
            <div className="w-7 h-7 rounded-full bg-primary-100 flex items-center justify-center">
              <span className="text-[10px] font-bold text-primary-700">
                {getInitials(profile.full_name)}
              </span>
            </div>
            <div className="hidden md:block">
              <p className="text-xs font-medium text-surface-700">{profile.full_name}</p>
              <p className="text-[10px] text-surface-500 capitalize">{profile.role}</p>
            </div>
          </div>
        )}
      </div>
    </header>
  )
}
